exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._374M96-wV393lxV-hBKaAu{padding:15px 0px}._3OlBmrF258JzWISGb6sl1o{font-size:13px;color:#616161;line-height:20px}\n", ""]);

// Exports
exports.locals = {
	"content": "_374M96-wV393lxV-hBKaAu",
	"createdAt": "_3OlBmrF258JzWISGb6sl1o"
};